import _ from 'lodash'
import React from 'react'
import { connect } from 'react-redux'

import { makeAutobindedInput } from './FormBuilder'
import { SelectField } from './Select'

const selectStyle = {
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'pre'
}

class PractitionerSelectField_ extends React.Component {
  render () {
    const { practitioners, filterFn: propFilterFn, ...rest } = this.props
    const filterFn = propFilterFn || _.identity
    const selected = _.get(this.props, 'value.id')

    const possible = practitioners.filter(
      practitioner => practitioner.active || selected === practitioner.id
    )

    const options = (filterFn(possible) || []).map(practitioner => {
      const { id: value, display } = practitioner
      const label = (practitioner.active && display) || `${display} (inactive)`

      return {
        value,
        code: value,
        label
      }
    })

    return (
      <SelectField
        style={selectStyle}
        label='Practitioner'
        {...rest}
        onChange={(value) => {
          rest.onChange(value
            ? {
              id: value,
              display: practitioners.find((p) => p.id === value).display
            }
            : null)
        }}
        value={rest?.value?.id}
        options={options}
      />
    )
  }
}

const mapStateToProps = redux => ({
  practitioners: redux.users.practitioners
})

export const PractitionerSelectField = connect(mapStateToProps)(
  PractitionerSelectField_
)

export const PractitionerSelectInput = makeAutobindedInput(
  PractitionerSelectField
)
